module.exports = __webpack_public_path__ + "static/img/error.1d53770.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/error.png
// module id = FF+y
// module chunks = 4